import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ObjHlp } from 'src/lib/fliko/helpers/object.helper';
import { EstateType } from 'src/lib/fliko/models/estate/estate.data';
import { NoteType } from 'src/lib/fliko/models/notes/notes.data';
import { ResidentType } from 'src/lib/fliko/models/person/resident.data';
import { RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { UserData } from 'src/lib/fliko/models/users/user.data';
import { GrammarHelper } from 'src/app/shared/helpers/grammar.helper';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { UserPRSList } from '../../../services/models/users-table.data';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-users-prs-landlord-tenant-details',
  templateUrl: './users-prs-landlord-tenant-details.component.html',
  styleUrls: ['./users-prs-landlord-tenant-details.component.scss']
})
export class UsersPrsLandlordTenantDetailsComponent implements OnInit, OnDestroy {
  public isAppInviteSent = false;
  public canEdit = false;
  public canAuth = false;
  public canMessage = false;
  public canAlert = false;
  public user: UserData | null = null;

  public get anyBasicDataExist(): boolean {
    const basicDataKeys = ['birthDate', 'PESEL', 'documentNo', 'nationality', 'NIP', 'REGON', 'ownerCode', 'address'];
    return ObjHlp.haveAny(this.data.resident, basicDataKeys);
  }

  public showOwnerCodes = false;

  private subscription$: Subscription = new Subscription();

  RentalUnitType = RentalUnitType;
  ResidentType = ResidentType;
  NoteType = NoteType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserPRSList.ResidentElement,
    public dialogRef: MatDialogRef<UsersPrsLandlordTenantDetailsComponent>,
    private userService: UserService,
    private router: Router,
    private ls: LocalizationService,
    private ctxDS: ContextDataService
  ) {}

  ngOnInit(): void {
    this.subscription$.add(
      this.ctxDS.contextPerms$.subscribe((perms) => {
        const isSuperAdmin = perms?.superAdmin;
        const p = perms?.ePerm?.user;
        const web = perms?.feat?.web;
        this.canEdit = isSuperAdmin || !!p?.edit;
        this.canAuth = isSuperAdmin || !!p?.auth;
        this.canMessage = !!web?.messaging && (isSuperAdmin || !!perms?.ePerm?.chat?.view);
        this.canAlert = !!web?.alertSMS.enabled && (isSuperAdmin || !!perms?.ePerm?.news?.edit);
      })
    );
    this.getUser();
  }

  ngOnDestroy(): void {
    this.subscription$?.unsubscribe();
  }

  private getUser(): void {
    if (this.data.resident && this.data.resident.userId) {
      this.userService
        .getUser$(this.data.resident.userId)
        .pipe(take(1))
        .subscribe((user) => (this.user = user ?? null));
    }
  }

  public onEdit(): void {
    this.router.navigate(['/users/edit', this.data?.resident?.id]);
    this.dialogRef.close();
  }

  public getListData(element: string | string[]): string[] {
    return Array.isArray(element) ? element : [element];
  }

  public getResidentHRWithCase(caseShort: string) {
    return GrammarHelper.getResidentInCase(EstateType.PRS, this.data.type, caseShort, this.ls);
  }
}
